<template lang="pug">
	.ssml-insertion-silence-settings
		Popup(v-if="visible", :popupVisible.sync="visible", :width="540", :height="640", :title="$tCaption('Silence settings')", @hiding="$emit('hiding')", :autosize="true", :closeOnOutsideClick="false")
			.flex-col.space.ssml-insertion-silence-settings
				.silence-type(v-for="silence in silenceTypes")
					.flex-row.justify
						.flex-col.flex-1
							.flex-row
								.flex-row.space.align-center.clickable.hoverable(@click="silence.enabled = !silence.enabled")
									DxCheckBox(:value="silence.enabled")
									.font-big {{silence.text}}
							.font-small.grey {{silence.hint}}
						.flex-row.space(v-if="silence.enabled")
							.flex-col.field(v-if="silence.exactSupported")
								.font-small.grey {{$tCaption('Type')}}
								DxSelectBox(:data-source="exactOptions", valueExpr="exact", displayExpr="text", :value.sync="silence.exact", :width="120")
							.flex-col.field
								.font-small.grey {{$tCaption('Value (ms)')}}
								DxNumberBox(:value.sync="silence.value", :width="50")
			template(slot="actions-right")
				DxButton(text="Save", type="default", @click="save")
				DxButton(text="Cancel", @click="() => visible = false")
</template>

<script>
	import _ from 'lodash';
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxSelectBox from 'devextreme-vue/select-box';

	export default {
		translationCategory: 'insertion.SSMLSilenceSettings',
		name: 'ssml-insertion-silence-settings',
		props: ['ssml'],
		components: { Popup, DxButton, DxCheckBox, DxNumberBox, DxSelectBox },
		data() {
			const silenceTypes = [
				{
					option: 'leadingsilence',
					text: this.$tCaption('Leading'),
					hint: this.$tCaption('Silence at the beginning of a paragraph.'),
					exactSupported: true,
					enabled: false,
					exact: false,
					value: 0
				},
				{
					option: 'tailingsilence',
					text: this.$tCaption('Tailing'),
					hint: this.$tCaption('Silence at the end of a paragraph.'),
					exactSupported: true,
					enabled: false,
					exact: false,
					value: 0
				},
				{
					option: 'sentenceboundarysilence',
					text: this.$tCaption('Sentence boundary'),
					hint: this.$tCaption('Silence between adjacent sentences.'),
					exactSupported: true,
					enabled: false,
					exact: false,
					value: 0
				},
				{
					option: 'commasilence-exact',
					text: this.$tCaption('Comma'),
					hint: this.$tCaption('Silence at the comma in half/full-width format.'),
					exactSupported: false,
					enabled: false,
					value: 0
				},
				{
					option: 'semicolonsilence-exact',
					text: this.$tCaption('Semicolon'),
					hint: this.$tCaption('Silence at the semicolon in half/full-width format.'),
					exactSupported: false,
					enabled: false,
					value: 0
				},
				{
					option: 'enumerationcommasilence-exact',
					text: this.$tCaption('Enumeration comma'),
					hint: this.$tCaption('Silence at the enumeration comma in full-width format.'),
					exactSupported: false,
					enabled: false,
					value: 0
				},
			];
			return {
				visible: false,
				exactOptions: [
					{ exact: false, text: this.$tCaption('Additional') },
					{ exact: true, text: this.$tCaption('Exact') }
				],
				silenceTypes: _.cloneDeep(silenceTypes)
			};
		},
		computed: {
		},
		watch: {
		},
		mounted() {
			if (__DEBUG__)
				window.ssmlSilenceSettings = this;
		},
		destroyed() {
		},
		methods: {
			show() {
				this.visible = false;
				this.restoreValues();
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.visible = true;
				});
			},
			save() {
				this.$emit('save', this.silenceTypes);
				this.visible = false;
			},
			restoreValues() {
				if (!this.ssml) return;

				const doc = document.createElement('div');
				doc.innerHTML = typeof(this.ssml) === 'function' ? this.ssml() : this.ssml;

				const voice = doc.querySelector('voice');

				this.silenceTypes.map(f => {
					let val = voice && voice?.getAttribute(f.option);
					let isExact = false;
					if (!val && f.exactSupported) {
						val = voice && voice?.getAttribute(f.option + '-exact');
						isExact = !!val;
					}
					f.enabled = !!val;
					f.value = val ? parseInt(val.replace(/[ms]/g, '')) : 0;
					f.exact = f.exactSupported && isExact;
				});
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.ssml-insertion-silence-settings {
		
	}
</style>
